import { Component } from '@angular/core';
import { CommonModule } from '@angular/common'; // Importar CommonModule
import {
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ModalInsertEmailComponent } from '../../components/modal-insert-email/modal-insert-email.component';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'aig-login',
  imports: [ReactiveFormsModule, CommonModule, ModalInsertEmailComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  constructor(private router: Router, private AuthService: AuthService) {
    this.buildForm();
  }

  //#region PRIVATE METHODS
  private buildForm(): void {
    this.loginForm = new FormGroup({
      usuario: new FormControl('', Validators.required),
      contraseña: new FormControl('', Validators.required),
    });
  }
  //#endregion

  //#region PUBLIC METHODS

  public readonly supportEmail: string = 'backoffice.caixa@icp.es';
  public showPassword: boolean = false;
  public errorlogin: boolean = false;
  public visibleInsertEmailModal: boolean = false;

  public loginForm: FormGroup = new FormGroup({});

  public sendData(): void {
    if (this.loginForm.valid) {
      this.AuthService.login(
        this.loginForm.value.usuario,
        this.loginForm.value.contraseña
      ).subscribe({
        next: (res: any) => {

          const respLogin = typeof res === 'string' ? JSON.parse(res) : res; // Verifica si es string o ya es objeto
          //console.log(respLogin);
          if (respLogin.status === 'success') {
            // Si el login es exitoso, guarda el token y navega a la página de bienvenida
            this.AuthService.saveToken(respLogin.ih, respLogin.idUsuario);
            if (respLogin.cambiarPassword) {
              this.router.navigate(['/auth/reset-password'], {
                queryParams: { t: respLogin.idUsuario },
              });
            } else {
              //console.log("navegar area cliente");
              this.router.navigate(['area-cliente']);
            }
            this.errorlogin = false;
          }
        },
        error: (err) => {
          this.errorlogin = true;
        },
      });
    }
  }

  public forgetPassword() {
    this.visibleInsertEmailModal = true;
  }

  public CloseModal() {
    this.visibleInsertEmailModal = false;
  }
  //#endregion
}
